export class RenderArgumentsDto {
  preview: boolean;
  autoRotate: boolean;
  noBackground: boolean;
  antialias: boolean;
  noGui: boolean;
  noInitialLogs: boolean;
  arenaMode: boolean;
  arenaIndex: string;
  geneticSequence: string;
  lights: boolean;
  htmlBackgroundColor: string;
  extensionTraits?: string;

  constructor(arg: Partial<RenderArgumentsDto>) {
    this.preview = arg.preview;
    this.autoRotate = arg.autoRotate;
    this.noBackground = arg.noBackground;
    this.antialias = arg.antialias;
    this.noGui = arg.noGui;
    this.noInitialLogs = arg.noInitialLogs;
    this.arenaMode = arg.arenaMode;
    this.arenaIndex = arg.arenaIndex;
    this.geneticSequence = arg.geneticSequence;
    this.lights = arg.lights;
    this.htmlBackgroundColor = arg.htmlBackgroundColor;
    this.extensionTraits = arg.extensionTraits;
  }
}
